enum RouteEnum {
    Login = '/',
    Dashboard = '/dashboard',
    Operation = '/challenge',
    NotFound = '/not-found',
    Recipient = '/recipient',
}

export default RouteEnum;
